/**
 * 运行环境判断与渠道认证工具（参考 hf-smoke-ui）
 * 企业微信内置浏览器 UA 含 wxwork
 * 飞书内置浏览器 UA 含 Lark 或 Feishu
 */
const FEISHU_APP_ID = process.env.VUE_APP_FEISHU_APP_ID

export function isInWxWork() {
  return /wxwork/i.test(window.navigator.userAgent)
}

export function isInFeishu() {
  return /lark|feishu/i.test(window.navigator.userAgent)
}

/**
 * 跳转企业微信网页授权链接获取 code（授权后带 code 回跳当前页面）
 * 企业微信工作台直接打开普通主页 URL 不会自动带 code，必须主动跳一次 authorize 授权链接
 * redirect_uri 指向当前完整页面地址，回跳后 URL 带 code，由路由守卫直调 qw-login 换会话
 * scope=snsapi_base 为静默授权（企微内不弹确认框）
 */
export function redirectToQwAuth() {
  const corpId = process.env.VUE_APP_QW_CORP_ID
  const agentId = process.env.VUE_APP_QW_AGENT_ID
  const redirectUri = encodeURIComponent(window.location.href)
  const state = Math.random().toString(36).substring(2)
  window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + corpId +
    '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_base&state=' + state +
    '&agentid=' + agentId + '#wechat_redirect'
}

/**
 * 跳转飞书 OAuth 授权页获取 code（授权后带 code 回跳当前站点根）
 * redirect_uri 固定用站点根地址（不带路由路径），需与飞书后台"安全设置-重定向 URL"配置完全一致
 * scope 需与飞书后台"权限管理"中已开通的用户身份权限一致（空格分隔）
 */
export function redirectToFeishuAuth() {
  const appId = FEISHU_APP_ID
  const redirectUri = encodeURIComponent(window.location.origin)
  const scope = encodeURIComponent('contact:contact.base:readonly contact:user.employee_number:read')
  const state = Math.random().toString(36).substring(2)
  window.location.href = 'https://accounts.feishu.cn/open-apis/authen/v1/authorize?app_id=' + appId +
    '&redirect_uri=' + redirectUri + '&response_type=code&scope=' + scope + '&state=' + state
}
